export const initialState = {
  ready: false
};
